<template>
  <div ref="page" class="special-func">
    <base-form
      ref="form"
      class="search-bar"
      v-model="toolbar.data"
      :form-items="toolbar.formItems"
      label-width="auto"
      input-trim
      inline
    ></base-form>
    <base-table-lite
      ref="table"
      url="view/getSpecialFuncDataExt"
      :columns="columns"
      :init-search="false"
      @loaded="tableLoaded"
    ></base-table-lite>
  </div>
</template>

<script>
export default {
  name: 'special-func-en',
  data() {
    var currentLang = this.$root.getCurrentLang()
    var currentRegion = this.$root.getCurrentRegion()
    //this.firstLoad = true
    return {
      defaultSearchField: [
        'brand',
        'area',
        'year',
        'series',
        'chassis',
        'model',
        'system',
        'system_type'
      ],
      currentLang,
      currentLangLowerCase: currentLang.toLowerCase(),
      currentProduct: '',
      currentFunc: '',
      toolbar: {
        formItems: [
          {
            label: currentLang == 'CN' ? '产品' : 'Product',
            prop: 'product',
            component: 'product-select',
            bind: {
              lang: currentLang,
              region: currentRegion,
              category: 'special',
              profile: this.getProfile()
            },
            on: {
              productChange: (product) => {
                this.currentProduct = product.profile
                this.$nextTick(() => {
                  this.toolbar.formItems[1].bind.profile = product.profile
                  this.toolbar.formItems[3].bind.profile = product.profile
                })
              }
            }
          },
          {
            label: currentLang == 'CN' ? '功能' : 'Function',
            prop: 'pack_func',
            component: 'special-func-select-v1',
            bind: {
              lang: currentLang,
              category: 'special',
              profile: '',
              packid: this.getPackId(),
              version: this.getPackVersion()
            },
            on: {
              outVersion: (option, versions) => {
                this.currentFunc = option.func
                this.toolbar.query.function = JSON.stringify({
                  Field: 'function',
                  ComparePattern: 'EQ',
                  Values: [option.func]
                })
                this.$nextTick(() => {
                  this.toolbar.formItems[2].bind.versions = versions
                  this.toolbar.formItems[3].bind.packid = option.packid
                  this.toolbar.query.maintenance = option.packid.split('_')[1]
                })
              }
            }
          },

          {
            label: currentLang == 'CN' ? '版本' : 'Version',
            prop: 'version',
            component: 'version-select-v1',
            bind: { versions: [], version: this.getPackVersion() },
            on: {
              outArea: (option, areas) => {
                const { version, packid } = option
                const queryObj = {
                  product: this.currentProduct,
                  func: this.currentFunc,
                  version,
                  packid
                }
                //构建查询信息
                this.toolbar.query.packid = option.packid
                this.toolbar.query.version = option.version
                this.$nextTick(() => {
                  this.toolbar.formItems[3].bind.version = option.version
                })
              }
            }
          },

          {
            label: currentLang == 'CN' ? '品牌' : 'Brand',
            prop: 'pack_brand',
            component: 'brand-select-v1',
            bind: {
              lang: currentLang,
              category: 'diag',
              profile: '',
              packid: '',
              version: '',
              index: '',
              changeIndex: 0
            },
            on: {
              outVersion: (option, versions) => {
                const { profile, brand, packid, version } = option
                const queryObj = { profile, brand, packid, version }
                this.toolbar.query.packid = option.packid
                this.toolbar.query.brand = option.brand
                const formItemVersion = this.toolbar.formItems[4]
                this.$nextTick(() => {
                  formItemVersion.bind.queryObj = queryObj
                  formItemVersion.bind.version = versions
                })
              }
            }
          },
          {
            label: currentLang == 'CN' ? '版本' : 'Version',
            prop: 'packVersion',
            component: 'version-select',
            bind: { version: [] },
            on: {
              change: (currentVersion) => {
                // if (option == null || option.length == 0) {
                //   this.initToolbarFormItems()
                //   //清空table
                //   this.toolbar.query.brand = null
                //   this.table.setTableData({
                //     rows: [],
                //     total: 0,
                //   })
                //   return
                // }
                this.$nextTick(() => {
                  this.getDiagField()
                })
              }
            }
          }
        ],
        data: {},
        query: {
          packid: null,
          function: null,
          version: null
        }
      },
      columns: []
    }
  },
  created() {
    this.$root.autoSetCurrentLang()
  },
  computed: {
    table() {
      return this.$refs.table
    },
    form() {
      return this.$refs.form
    }
  },
  methods: {
    getProfile() {
      return this.$route.query.configName
    },
    getPackId() {
      return this.$route.query.packId
    },
    getPackVersion() {
      return this.$route.query.packVer
    },
    assertField(field) {
      //这些列不显示
      if (['brand', 'version', 'function'].indexOf(field) > -1) {
        return false
      }
      return true
    },

    getDiagField() {
      var searchData = this.toolbar.data
      this.$post('view/getDiagField', {
        packid: this.toolbar.query.packid,
        version: searchData.packVersion,
        lang: this.currentLang
      })
        .then((resp) => {
          if (resp.data.code == 0) {
            var columns = []
            this.searchFieldFormItems = []
            var currentFields = []
            this.initToolbarFormItems()
            var fieldIndex = 0
            for (var item of resp.data.data) {
              //过滤不显示的列
              if (!this.assertField(item.field)) {
                continue
              }
              var column = {
                bind: {
                  label: item[this.currentLang.toLowerCase()],
                  prop: item.field
                }
              }
              //用对应组件渲染显示数据类型
              if (item.data_type || item.field == 'maintenance') {
                continue
              }
              columns.push(column)
              //查找动态查询条件框
              if (this.defaultSearchField.indexOf(item.field) > -1) {
                currentFields.push(item.field)
                this.searchFieldFormItems.push({
                  label: item[this.currentLang.toLowerCase()],
                  prop: item.field,
                  component: 'field-select',
                  bind: {
                    fieldIndex: fieldIndex,
                    category: 'diag',
                    field: item.field,
                    lang: this.currentLang,
                    packid: this.toolbar.query.packid,
                    version: searchData.packVersion
                    //brand: this.currentBrand,
                  },
                  on: {
                    valchange: (index, val) => {
                      this.resetSearchFieldBeginBy(index, val)
                      this.tableSearch()
                    }
                  }
                })
                fieldIndex++
              }
            }
            this.currentFields = currentFields
            this.columns = columns
            this.$nextTick(() => {
              for (var item of this.searchFieldFormItems) {
                this.toolbar.formItems.push(item)
              }
              //第一个动态查询条件框价值初始化option
              this.firstSearchFieldInit()
              this.tableSearch()
            })
          } else {
            this.$message(resp.data.msg || '获取数据失败')
            this.initToolbarFormItems()
          }
        })
        .catch((error) => {
          console.error(error)
          this.$message('请求发生错误=>' + error)
          this.initToolbarFormItems()
        })
    },
    initToolbarFormItems() {
      if (this.toolbar.formItems.length > 5) {
        //找出多余的prop
        var props = []
        for (var i = 5; i < this.toolbar.formItems.length; i++) {
          props.push(this.toolbar.formItems[i].prop)
        }
        this.toolbar.formItems.splice(5)
        //删除多余的prop
        for (var prop of props) {
          this.$delete(this.toolbar.data, prop)
        }
      }
    },
    getSearchData() {
      var searchData = Object.assign({}, this.toolbar.data, this.toolbar.query)
      // console.log('searchData: ',searchData)
      for (var field of this.defaultSearchField) {
        if (searchData[field]) {
          searchData[field] = JSON.stringify({
            Field: field,
            ComparePattern: 'EQ',
            Values: [searchData[field]]
          })
        }
      }
      return searchData
    },
    tableSearch() {
      this.table.table.doLayout()
      this.$nextTick(() => {
        this.table.searchData = this.getSearchData()
        this.table.searchData.lang = this.currentLang
        this.table.query.PageIndex = 1
        this.table.refreshData()
      })
    },
    tableLoaded() {
      window.parent.postMessage(
        {
          callback: 'setIframeHeight',
          args: [this.$refs.page.scrollHeight + 50]
        },
        '*'
      )
    },
    firstSearchFieldInit() {
      this.$nextTick(() => {
        var searchData = this.getSearchData()
        for (var item of this.$refs.form.items) {
          if (item.fieldIndex == 0) {
            item.getFieldOptions(searchData)
            break
          }
        }
      })
    },
    resetSearchFieldBeginBy(index, val) {
      var searchData = this.getSearchData()
      for (var item of this.$refs.form.items) {
        if (item.fieldIndex > index) {
          item.reset()
          if (val && item.fieldIndex == index + 1) {
            item.getFieldOptions(searchData)
          }
        }
      }
    }
  }
}
</script>
<style lang="less">
.special-func {
}
</style>
